var SocialLinkType;
(function (SocialLinkType) {
    SocialLinkType["INSTAGRAM"] = "instagram";
    SocialLinkType["TELEGRAM"] = "telegram";
    SocialLinkType["FACEBOOK"] = "facebook";
    SocialLinkType["VK"] = "vk";
    SocialLinkType["VIBER"] = "viber";
    SocialLinkType["OK"] = "ok";
    SocialLinkType["DZEN"] = "dzen";
})(SocialLinkType || (SocialLinkType = {}));

export { SocialLinkType };
//# sourceMappingURL=Socials.types.js.map
